var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailDesativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12923 10.0308C8.59283 10.1361 8.13686 10.6014 8.0329 11.1496C7.98903 11.3809 7.98903 19.8616 8.0329 20.0928C8.13933 20.654 8.59252 21.1072 9.1537 21.2136C9.3863 21.2578 22.6137 21.2578 22.8463 21.2136C23.4075 21.1072 23.8607 20.654 23.9671 20.0928C24.011 19.8616 24.011 11.3809 23.9671 11.1496C23.8607 10.5885 23.4075 10.1353 22.8463 10.0288C22.6371 9.98917 9.33152 9.99101 9.12923 10.0308ZM19.6407 13.6721C17.7669 15.536 16.8367 16.44 16.7192 16.5112C16.2813 16.7767 15.7187 16.7767 15.2808 16.5112C15.1633 16.44 14.2331 15.536 12.3593 13.6721L9.61017 10.9376H16H22.3898L19.6407 13.6721ZM11.7348 14.3694L12.9845 15.6213L11.4223 17.1856C10.5631 18.0459 9.65273 18.9475 9.39926 19.1889L8.93838 19.6279V15.6211V11.6143L9.71172 12.3659C10.1371 12.7793 11.0474 13.6809 11.7348 14.3694ZM23.054 17.6288L23.046 19.6364L21.0306 17.6282L19.0152 15.6199L21.0306 13.6152L23.046 11.6106L23.054 13.6159C23.0585 14.7189 23.0585 16.5246 23.054 17.6288ZM13.9852 16.6229C14.5507 17.1928 14.8783 17.4196 15.3438 17.5637C15.54 17.6244 15.6469 17.6362 16 17.6362C16.4804 17.6362 16.7309 17.5777 17.0936 17.381C17.3622 17.2353 17.5041 17.1192 17.9594 16.6728L18.3409 16.2988L19.0843 17.0204C19.4931 17.4172 20.4041 18.3193 21.1086 19.025L22.3895 20.3082L15.9998 20.3068L9.61017 20.3055L11.6196 18.3071C12.7248 17.208 13.639 16.3087 13.6512 16.3087C13.6634 16.3087 13.8137 16.4501 13.9852 16.6229Z",
    fill: "#757575",
    stroke: "#757575",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDesativo);
export default __webpack_public_path__ + "static/media/Email-Desativo.b6802b7f.svg";
export { ForwardRef as ReactComponent };